// Print utility functions for generating print-friendly HTML

import eurekalogo from '../assets/images/eurekalogo.png';

export const generateEmployeePrintHTML = (employee) => {
  const formatDate = (dateString) => {
    if (!dateString) return '-';
    return new Date(dateString).toLocaleDateString('id-ID', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  const formatCurrency = (amount) => {
    if (!amount) return '-';
    const numericAmount = amount.toString().replace(/\./g, '');
    return `Rp ${parseInt(numericAmount).toLocaleString('id-ID')}`;
  };

  return `
    <!DOCTYPE html>
    <html lang="id">
    <head>
      <meta charset="UTF-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <title>Data Karyawan - ${employee.full_name}</title>
      <style>
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }
        
        body {
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
          line-height: 1.6;
          color: #1a1a1a;
          background: white;
          font-size: 14px;
        }
        
        .print-container {
          max-width: 210mm;
          margin: 0 auto;
          padding: 20mm;
          background: white;
        }
        
        .header {
          display: flex;
          align-items: center;
          margin-bottom: 40px;
          padding-bottom: 20px;
          border-bottom: 2px solid #e5e7eb;
        }
        
        .logo {
          width: 60px;
          height: 60px;
          margin-right: 20px;
          object-fit: contain;
        }
        
        .header-text {
          flex: 1;
        }
        
        .company-name {
          font-size: 28px;
          font-weight: 700;
          color: #1f2937;
          margin-bottom: 4px;
          letter-spacing: -0.5px;
        }
        
        .document-title {
          font-size: 16px;
          color: #6b7280;
          margin-bottom: 8px;
          font-weight: 500;
        }
        
        .print-date {
          font-size: 12px;
          color: #9ca3af;
        }
        
        .main-grid {
          display: grid;
          grid-template-columns: 1fr 2fr;
          gap: 24px;
          margin-bottom: 32px;
        }
        
        .card {
          background: white;
          border-radius: 12px;
          box-shadow: 0 4px 20px rgba(0,0,0,0.1);
          margin-bottom: 24px;
          overflow: hidden;
          page-break-inside: avoid;
        }
        
        .card-header {
          background: #f5f5f5;
          padding: 16px 20px;
          border-bottom: 1px solid #e5e7eb;
          display: flex;
          align-items: center;
          gap: 12px;
        }
        
        .card-icon {
          width: 32px;
          height: 32px;
          background: #6b7280;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-size: 16px;
        }
        
        .card-title {
          font-size: 18px;
          font-weight: 600;
          color: #1a1a1a;
        }
        
        .card-content {
          padding: 20px;
        }
        
        .profile-section {
          text-align: center;
          margin-bottom: 24px;
        }
        
        .profile-photo {
          width: 120px;
          height: 120px;
          border-radius: 50%;
          border: 4px solid #e3f2fd;
          object-fit: cover;
          margin-bottom: 16px;
        }
        
        .profile-name {
          font-size: 20px;
          font-weight: 600;
          color: #1a1a1a;
          margin-bottom: 8px;
        }
        
        .profile-subtitle {
          font-size: 14px;
          color: #6b7280;
          margin-bottom: 12px;
        }
        
        .status-chip {
          display: inline-block;
          padding: 6px 16px;
          border-radius: 20px;
          font-size: 12px;
          font-weight: 600;
        }
        
        .status-active {
          background: #dcfce7;
          color: #166534;
        }
        
        .status-inactive {
          background: #fef2f2;
          color: #991b1b;
        }
        
        .info-list {
          list-style: none;
          padding: 0;
        }
        
        .info-item {
          display: flex;
          align-items: center;
          padding: 8px 0;
          border-bottom: 1px solid #f3f4f6;
        }
        
        .info-item:last-child {
          border-bottom: none;
        }
        
        .info-icon {
          width: 20px;
          height: 20px;
          margin-right: 12px;
          color: #3b82f6;
          font-size: 16px;
        }
        
        .info-content {
          flex: 1;
        }
        
        .info-label {
          font-size: 12px;
          font-weight: 600;
          color: #374151;
          margin-bottom: 2px;
        }
        
        .info-value {
          font-size: 13px;
          color: #1f2937;
        }
        
        .section-title {
          font-size: 18px;
          font-weight: 700;
          color: #1a1a1a;
          margin-bottom: 20px;
          padding-bottom: 8px;
          border-bottom: 2px solid #e5e7eb;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }
        
        .info-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
          gap: 16px;
          margin-bottom: 24px;
        }
        
        .info-item-grid {
          display: flex;
          padding: 12px 0;
          border-bottom: 1px solid #f3f4f6;
        }
        
        .info-label-grid {
          font-weight: 600;
          min-width: 160px;
          color: #374151;
          font-size: 13px;
        }
        
        .info-value-grid {
          flex: 1;
          color: #1f2937;
          font-size: 13px;
        }
        
        .table {
          width: 100%;
          border-collapse: collapse;
          margin-bottom: 24px;
          border: 1px solid #e5e7eb;
          border-radius: 8px;
          overflow: hidden;
        }
        
        .table th {
          background: #f9fafb;
          padding: 12px 16px;
          text-align: left;
          font-weight: 600;
          border-bottom: 1px solid #e5e7eb;
          font-size: 12px;
          color: #374151;
        }
        
        .table td {
          padding: 12px 16px;
          border-bottom: 1px solid #f3f4f6;
          font-size: 12px;
          color: #1f2937;
        }
        
        .table tr:last-child td {
          border-bottom: none;
        }
        
        .two-column {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 24px;
        }
        
        .subsection-title {
          font-size: 16px;
          font-weight: 600;
          color: #3b82f6;
          margin-bottom: 12px;
          padding-bottom: 8px;
          border-bottom: 1px solid #e5e7eb;
        }
        
        .highlight-value {
          color: #059669;
          font-weight: 600;
        }
        
        .warning-value {
          color: #d97706;
          font-weight: 600;
        }
        
        @media print {
          body { -webkit-print-color-adjust: exact; }
          .print-container { margin: 0; padding: 15mm; }
          .card { page-break-inside: avoid; }
        }
      </style>
    </head>
    <body>
      <div class="print-container">
        <div class="header">
          <img src="${eurekalogo}" alt="Eureka Group" class="logo">
          <div class="header-text">
            <div class="company-name">EUREKA GROUP</div>
            <div class="document-title">Data Karyawan</div>
            <div class="print-date">Dicetak pada: ${new Date().toLocaleDateString('id-ID')}</div>
          </div>
        </div>

        <div class="main-grid">
          <!-- Left Column - Personal Data Card -->
          <div>
            <div class="card">
              <div class="card-header">
                <div class="card-icon">👤</div>
                <div class="card-title">Data Pribadi</div>
          </div>
              <div class="card-content">
                <div class="profile-section">
                  <img src="${employee.photo || 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSIxMjAiIGhlaWdodD0iMTIwIiBmaWxsPSIjRjNGNEY2Ii8+CjxjaXJjbGUgY3g9IjYwIiBjeT0iNDAiIHI9IjE4IiBmaWxsPSIjOUNBM0FGIi8+CjxwYXRoIGQ9Ik0zMCA5MEMzMCA3Ni4wODU2IDQxLjA4NTYgNjUgNTUgNjVINjVDNzguOTE0NCA2NSA5MCA3Ni4wODU2IDkwIDkwVjEyMEgzMFY5MFoiIGZpbGw9IiM5Q0EzQUYiLz4KPC9zdmc+'}" alt="Foto Karyawan" class="profile-photo">
                  <div class="profile-name">${employee.full_name || employee.staticData?.personalData?.full_name || '-'}</div>
                  <div class="profile-subtitle">ID: ${employee.emp_id || employee.staticData?.personalData?.employee_code || '-'}</div>
                  <div class="status-chip ${employee.is_active === 'Active' ? 'status-active' : 'status-inactive'}">
                    ${employee.is_active || (employee.staticData?.personalData?.active_status === 1 ? 'Active' : 'Inactive') || '-'}
            </div>
            </div>

                <ul class="info-list">
                  <li class="info-item">
                    <span class="info-icon">📅</span>
                    <div class="info-content">
                      <div class="info-label">Tempat, Tanggal Lahir</div>
                      <div class="info-value">${employee.staticData?.personalData?.birth_place || '-'}, ${formatDate(employee.birth_date || employee.staticData?.personalData?.birth_date)}</div>
            </div>
                  </li>
                  <li class="info-item">
                    <span class="info-icon">👤</span>
                    <div class="info-content">
                      <div class="info-label">Jenis Kelamin</div>
                      <div class="info-value">${employee.sex || (employee.staticData?.personalData?.gender === 'L' ? 'Laki-laki' : 'Perempuan') || '-'}</div>
            </div>
                  </li>
                  <li class="info-item">
                    <span class="info-icon">📧</span>
                    <div class="info-content">
                      <div class="info-label">Email</div>
                      <div class="info-value">${employee.email || employee.staticData?.contact?.corporate_email || '-'}</div>
            </div>
                  </li>
                  <li class="info-item">
                    <span class="info-icon">📞</span>
                    <div class="info-content">
                      <div class="info-label">Telepon</div>
                      <div class="info-value">${employee.no_telp || employee.staticData?.contact?.mobile_phone || '-'}</div>
            </div>
                  </li>
                  <li class="info-item">
                    <span class="info-icon">📍</span>
                    <div class="info-content">
                      <div class="info-label">Alamat</div>
                      <div class="info-value">${employee.address || employee.staticData?.address?.street || '-'}</div>
            </div>
                  </li>
                  <li class="info-item">
                    <span class="info-icon">🆔</span>
                    <div class="info-content">
                      <div class="info-label">NIK</div>
                      <div class="info-value">${employee.staticData?.personalData?.id_number || '-'}</div>
            </div>
                  </li>
                </ul>
            </div>
          </div>
        </div>

          <!-- Right Column -->
          <div>
            <!-- Work Information Card -->
        ${employee.staticData ? `
            <div class="card">
              <div class="card-header">
                <div class="card-icon">💼</div>
                <div class="card-title">Informasi Pekerjaan</div>
            </div>
              <div class="card-content">
          <div class="info-grid">
                  <div class="info-item-grid">
                    <span class="info-label-grid">Kantor:</span>
                    <span class="info-value-grid">${employee.id_office?.office_name || employee.staticData?.address?.location_id || '-'}</span>
            </div>
                  <div class="info-item-grid">
                    <span class="info-label-grid">Branch Name:</span>
                    <span class="info-value-grid">${employee.staticData?.workInfo?.branch_name || '-'}</span>
            </div>
                  <div class="info-item-grid">
                    <span class="info-label-grid">Level Pekerjaan:</span>
                    <span class="info-value-grid">${employee.id_job_level?.joblevel_name || '-'}</span>
            </div>
                  <div class="info-item-grid">
                    <span class="info-label-grid">Posisi Pekerjaan:</span>
                    <span class="info-value-grid">${employee.id_jobposition?.jobposition_name || employee.staticData?.workInfo?.position || '-'}</span>
            </div>
                  <div class="info-item-grid">
                    <span class="info-label-grid">Departemen:</span>
                    <span class="info-value-grid">${employee.id_department?.department_name || employee.staticData?.workInfo?.department || '-'}</span>
            </div>
                  <div class="info-item-grid">
                    <span class="info-label-grid">Unit Bisnis:</span>
                    <span class="info-value-grid">${employee.id_bu?.bu_name || employee.staticData?.workInfo?.business_unit || '-'}</span>
            </div>
                  <div class="info-item-grid">
                    <span class="info-label-grid">Grade:</span>
                    <span class="info-value-grid">${employee.grade || employee.staticData?.workInfo?.grade || '-'}</span>
            </div>
            </div>
            </div>
            </div>
            ` : ''}
            </div>
            </div>

        <!-- History Card -->
        ${employee.staticData?.history ? `
        <div class="card">
          <div class="card-header">
            <div class="card-icon">ℹ️</div>
            <div class="card-title">Riwayat</div>
          </div>
          <div class="card-content">
          <div class="info-grid">
              <div class="info-item-grid">
                <span class="info-label-grid">Alasan Keluar Kerja Terakhir:</span>
                <span class="info-value-grid">${employee.staticData.history.last_job_reason_leave || '-'}</span>
            </div>
              <div class="info-item-grid">
                <span class="info-label-grid">Gaji Terakhir:</span>
                <span class="info-value-grid highlight-value">${formatCurrency(employee.staticData.history.last_job_salary)}</span>
            </div>
              <div class="info-item-grid">
                <span class="info-label-grid">Pekerjaan yang Disukai:</span>
                <span class="info-value-grid">${employee.staticData.history.job_most_liked || '-'}</span>
            </div>
              <div class="info-item-grid">
                <span class="info-label-grid">Hobi:</span>
                <span class="info-value-grid">${employee.staticData.history.hobby || '-'}</span>
            </div>
              <div class="info-item-grid">
                <span class="info-label-grid">Waktu Luang:</span>
                <span class="info-value-grid">${employee.staticData.history.free_time || '-'}</span>
            </div>
              <div class="info-item-grid">
                <span class="info-label-grid">Topik Bacaan:</span>
                <span class="info-value-grid">${employee.staticData.history.reading_topics || '-'}</span>
            </div>
            </div>
          </div>
        </div>
        ` : ''}

        <!-- Family and Education Cards -->
        <div class="two-column">
        ${employee.staticData?.family && employee.staticData.family.length > 0 ? `
          <div class="card">
            <div class="card-header">
              <div class="card-icon">👨‍👩‍👧‍👦</div>
              <div class="card-title">Data Keluarga</div>
            </div>
            <div class="card-content">
          <div class="info-grid">
                <div class="info-item-grid">
                  <span class="info-label-grid">Status Pernikahan:</span>
                  <span class="info-value-grid">${employee.staticData?.personalData?.marital_status || '-'}</span>
            </div>
                <div class="info-item-grid">
                  <span class="info-label-grid">Tanggal Menikah:</span>
                  <span class="info-value-grid">${formatDate(employee.staticData?.personalData?.marital_date)}</span>
            </div>
          </div>
          
          <table class="table">
            <thead>
              <tr>
                <th>Jenis</th>
                <th>Nama</th>
                <th>L/P</th>
                <th>Usia</th>
                <th>Pekerjaan</th>
              </tr>
            </thead>
            <tbody>
              ${employee.staticData.family.map(member => `
                <tr>
                  <td>${member.type || '-'}</td>
                  <td>${member.name || '-'}</td>
                  <td>${member.gender || '-'}</td>
                  <td>${member.age || '-'}</td>
                  <td>${member.job || '-'}</td>
                </tr>
              `).join('')}
            </tbody>
          </table>
            </div>
        </div>
        ` : ''}

        ${employee.staticData?.education && employee.staticData.education.length > 0 ? `
          <div class="card">
            <div class="card-header">
              <div class="card-icon">🎓</div>
              <div class="card-title">Pendidikan Formal</div>
            </div>
            <div class="card-content">
          <table class="table">
            <thead>
              <tr>
                <th>Jenjang</th>
                <th>Nama Sekolah</th>
                <th>Lokasi</th>
                <th>Tahun Lulus</th>
                <th>Nilai/IPK</th>
                <th>Jurusan</th>
              </tr>
            </thead>
            <tbody>
              ${employee.staticData.education.map(edu => `
                <tr>
                  <td>${edu.level || '-'}</td>
                  <td>${edu.school_name || '-'}</td>
                  <td>${edu.location || '-'}</td>
                  <td>${edu.graduation_year || '-'}</td>
                      <td class="highlight-value">${edu.gpa || '-'}</td>
                  <td>${edu.major || '-'}</td>
                </tr>
              `).join('')}
            </tbody>
          </table>
            </div>
        </div>
        ` : ''}
        </div>

        <!-- Documents Card -->
        ${employee.documents && employee.documents.length > 0 ? `
        <div class="card">
          <div class="card-header">
            <div class="card-icon">📄</div>
            <div class="card-title">Dokumen (${employee.documents.length})</div>
          </div>
          <div class="card-content">
          <table class="table">
            <thead>
              <tr>
                <th>Nama Dokumen</th>
                <th>Kategori</th>
                <th>Diupload Oleh</th>
                <th>Tanggal Upload</th>
              </tr>
            </thead>
            <tbody>
              ${employee.documents.map(doc => `
                <tr>
                  <td>${doc.document_name}</td>
                  <td>${doc.category_name || 'Unknown'}</td>
                  <td>${doc.full_name || '-'}</td>
                  <td>${formatDate(doc.date_added)}</td>
                </tr>
              `).join('')}
            </tbody>
          </table>
          </div>
        </div>
        ` : ''}
      </div>
    </body>
    </html>
  `;
};

export const generateCandidatePrintHTML = (candidate) => {
  // Helper function untuk format tanggal
  const formatDate = (dateString) => {
    if (!dateString) return '-';
    return new Date(dateString).toLocaleDateString('id-ID', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    });
  };

  // Data Statis sesuai dengan data di Candidate.js
  const data = {
    personal: {
      nama: candidate?.personalData?.full_name || '-',
      tempatLahir: candidate?.personalData?.birth_place || '-',
      tanggalLahir: candidate?.personalData?.birth_date ? formatDate(candidate.personalData.birth_date) : '-',
      agama: candidate?.personalData?.religion || '-',
      tinggiBadan: candidate?.personalData?.height_cm || '-',
      alamatKTP: candidate?.personalData?.address || '-',
      alamatDomisili: candidate?.personalData?.address || '-',
      email: candidate?.personalData?.email || '-',
      noKTP: candidate?.personalData?.id_number || '-',
      noHP: candidate?.personalData?.phone || '-',
      beratBadan: candidate?.personalData?.weight_kg || '-',
      usia: candidate?.personalData?.age || '-',
      daerah: candidate?.personalData?.id_region || '-',
      jenisKelamin: candidate?.personalData?.gender === 'Male' ? 'Laki-laki' : candidate?.personalData?.gender === 'Female' ? 'Perempuan' : '-',
      tinggal: candidate?.personalData?.living_status || '-',
      kendaraan: candidate?.personalData?.vehicle_ownership || '-'
    },
    pendidikan: candidate?.education?.map(edu => ({
      jenjang: edu.jenjang || '-',
      nama: edu.nama_sekolah || '-',
      tempat: edu.tempat || '-',
      tahun: edu.tahun_lulus || '-',
      nilai: edu.rata_rata_nilai || '-',
      jurusan: edu.jurusan || '-'
    })) || [],
    kursus: candidate?.courses?.map(course => ({
      instruktur: course.instruktur_lembaga || '-',
      tempat: course.tempat || '-',
      lama: course.lama_pendidikan || '-',
      biaya: course.yang_membiayai || '-',
      keterangan: course.keterangan || '-'
    })) || [],
    prestasi: {
      terbaik: candidate?.personalData?.best_achievement || '-',
      keteranganTerbaik: candidate?.personalData?.best_achievement_desc || '-',
      terendah: candidate?.personalData?.worst_achievement || '-',
      keteranganTerendah: candidate?.personalData?.worst_achievement_desc || '-'
    },
    bahasa: {
      aktif: candidate?.personalData?.language_active || '-',
      pasif: candidate?.personalData?.language_passive || '-'
    },
    beasiswa: candidate?.personalData?.scholarship || '-',
    pembiayaPendidikan: candidate?.personalData?.education_sponsor || '-',
    pengaruhPilihan: candidate?.personalData?.influence_note || '-',
    karyaIlmiah: candidate?.personalData?.publication || '-',
    nilaiSMA: {
      rataRata: candidate?.personalData?.highschool_avg_score?.toString() || '-',
      jumlahMataPelajaran: candidate?.personalData?.highschool_subject_count?.toString() || '-',
      nilaiUjian: '-',
      jumlahMataPelajaranUjian: '-',
      ipk: candidate?.personalData?.gpa?.toString() || '-',
      maksimum: candidate?.personalData?.gpa_max?.toString() || '4.00'
    },
    pekerjaan: candidate?.workHistory?.map(work => ({
      tahunMasuk: work.masuk ? new Date(work.masuk).getFullYear().toString() : '-',
      tahunKeluar: work.keluar ? new Date(work.keluar).getFullYear().toString() : '-',
      jabatan: work.jabatan || '-',
      perusahaan: work.perusahaan || '-',
      pekerjaan: work.keterangan || '-',
      alamatTelp: work.alamat_telp || '-',
      keterangan: work.keterangan || '-'
    })) || [],
    alasanKeluar: candidate?.history?.last_job_reason_leave || '-',
    gajiTerakhir: candidate?.history?.last_job_salary ? `Rp ${parseInt(candidate.history.last_job_salary).toLocaleString('id-ID')}` : '-',
    pekerjaanFavorit: candidate?.history?.job_most_liked || '-',
    pekerjaanTidakSuka: candidate?.history?.job_least_liked || '-',
    aktivitasSosial: candidate?.socialActivities?.map(activity => ({
      tahun: activity.tahun || '-',
      jenis: activity.jenis_aktivitas || '-',
      jabatan: activity.jabatan || '-',
      organisasi: activity.organisasi || '-'
    })) || [],
    hobi: candidate?.history?.hobby || '-',
    olahraga: candidate?.history?.sport ? 'Ya' : 'Tidak',
    keteranganOlahraga: candidate?.history?.sport_desc || '-',
    waktuLuang: candidate?.history?.free_time || '-',
    membaca: candidate?.history?.reading_hours || '-',
    topikBacaan: candidate?.history?.reading_topics || '-',
    suratKabar: candidate?.history?.newspaper || '-',
    majalah: candidate?.history?.magazine || '-'
  };

  return `
    <!DOCTYPE html>
    <html lang="id">
    <head>
      <meta charset="UTF-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <title>Formulir Data Pribadi Pelamar - ${data.personal.nama}</title>
      <style>
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }
        
        body {
          font-family: Arial, sans-serif;
          font-size: 10px;
          line-height: 1.2;
          color: #000;
          background: white;
          margin: 0;
          padding: 0;
        }
        
        .container {
          width: 210mm;
          margin: 0 auto;
          padding: 10mm;
          background: white;
          min-height: 100vh;
        }
        
        /* Header */
        .header {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          margin-bottom: 8px;
          padding-bottom: 6px;
          border-bottom: 3px solid #000;
        }
        
        .logo-section {
          flex: 1;
        }
        
        .logo-section img {
          height: 35px;
          margin-bottom: 4px;
        }
        
        .company-name {
          font-size: 24px;
          font-weight: 700;
          margin-bottom: 2px;
          letter-spacing: 3px;
          color: #1a1a1a;
          background: linear-gradient(135deg, #1e3a8a 0%, #3b82f6 50%, #1e3a8a 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          font-family: 'Helvetica Neue', 'Arial', sans-serif;
          text-transform: uppercase;
        }
        
        .company-info {
          font-size: 8px;
          line-height: 1.3;
          color: #374151;
          font-weight: 500;
        }
        
        .photo-box {
          width: 60px;
          height: 80px;
          border: 2px solid #000;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 8px;
          text-align: center;
          margin-left: 20px;
          flex-shrink: 0;
        }
        
        .title {
          text-align: center;
          font-size: 14px;
          font-weight: bold;
          margin: 10px 0 8px 0;
          letter-spacing: 1px;
        }
        
        /* Section */
        .section {
          margin-bottom: 12px;
          margin-top: 8px;
          page-break-inside: avoid;
        }
        
        .section-title {
          background-color: #d3d3d3;
          font-size: 11px;
          font-weight: bold;
          padding: 4px 6px;
          margin-bottom: 6px;
          border: 1px solid #000;
        }
        
        /* Table */
        table {
          width: 100%;
          border-collapse: collapse;
          margin-bottom: 8px;
          margin-top: 4px;
        }
        
        table td, table th {
          border: 1px solid #000;
          padding: 5px 6px;
          text-align: left;
          font-size: 9px;
          vertical-align: top;
        }
        
        table th {
          background-color: #e8e8e8;
          font-weight: bold;
          text-align: center;
          padding: 6px 6px;
        }
        
        .label-cell {
          font-weight: bold;
          background-color: #f5f5f5;
        }
        
        /* Two column layout */
        .two-column {
          display: flex;
          gap: 15px;
        }
        
        .column {
          flex: 1;
        }
        
        /* Checkbox options */
        .checkbox-line {
          display: flex;
          align-items: center;
          gap: 3px;
        }
        
        @media print {
          body { -webkit-print-color-adjust: exact; }
          .container { padding: 8mm; }
          .section { page-break-inside: avoid; }
        }
      </style>
    </head>
    <body>
      <div class="container">
        <!-- Header -->
        <div class="header">
          <div class="logo-section">
            <img src="${window.location.origin}/src/assets/images/eurekalogo.png" alt="Eureka Group" />

            <div class="company-info">
              Jl. H. Baping No. 100, Susukan, Ciracas, Kota Jakarta Timur, DKI Jakarta 13740<br>
              Telp: (021) 1234567 | Email: hrd@eurekagroup.id | Website: www.eurekagroup.id
            </div>
          </div>
          <div class="photo-box">
            Foto 4 x 6
          </div>
        </div>

        <!-- Title -->
        <div class="title">FORMULIR DATA PRIBADI PELAMAR</div>
        
        <!-- IDENTITAS -->
        <div class="section">
          <div class="section-title">IDENTITAS</div>
          
          <table>
            <tr>
              <td class="label-cell" style="width: 20%;">Nama</td>
              <td style="width: 55%;">${data.personal.nama}</td>
              <td class="label-cell" style="width: 15%;">Laki-laki / Perempuan</td>
              <td style="width: 10%;">${data.personal.jenisKelamin}</td>
            </tr>
            <tr>
              <td class="label-cell">Tempat / Tanggal lahir</td>
              <td>${data.personal.tempatLahir}, ${data.personal.tanggalLahir}</td>
              <td class="label-cell">Usia :</td>
              <td>${data.personal.usia} tahun</td>
            </tr>
            <tr>
              <td class="label-cell">Agama</td>
              <td>${data.personal.agama}</td>
              <td class="label-cell">No. HP :</td>
              <td>${data.personal.noHP}</td>
            </tr>
            <tr>
              <td class="label-cell">Tinggi badan</td>
              <td>${data.personal.tinggiBadan} cm</td>
              <td class="label-cell">Berat badan :</td>
              <td>${data.personal.beratBadan} kg</td>
            </tr>
            <tr>
              <td class="label-cell">Alamat Sesuai KTP :</td>
              <td colspan="3">${data.personal.alamatKTP}</td>
            </tr>
            <tr>
              <td class="label-cell">Alamat Domisili :</td>
              <td colspan="3">${data.personal.alamatDomisili}</td>
            </tr>
            <tr>
              <td class="label-cell">Alamat Email :</td>
              <td colspan="3">${data.personal.email}</td>
            </tr>
            <tr>
              <td class="label-cell">No. KTP :</td>
              <td>${data.personal.noKTP}</td>
              <td class="label-cell">Daerah :</td>
              <td>${data.personal.daerah}</td>
            </tr>
            <tr>
              <td class="label-cell">Saat ini tinggal di rumah:</td>
              <td colspan="3">
                ${data.personal.tinggal === 'Dinas' ? '☑' : '☐'} dinas /
                ${data.personal.tinggal === 'Parents' ? '☑' : '☐'} orang tua /
                ${data.personal.tinggal === 'Sewa' ? '☑' : '☐'} sewa /
                ${data.personal.tinggal === 'Indekos' ? '☑' : '☐'} indekos /
                ${data.personal.tinggal === 'Sendiri' ? '☑' : '☐'} sendiri /
                ${data.personal.tinggal === 'Menumpang' ? '☑' : '☐'} menumpang (${data.personal.tinggal})
              </td>
            </tr>
            <tr>
              <td class="label-cell">Kendaraan yang Anda pergunakan jenis:</td>
              <td colspan="3">
                ${data.personal.kendaraan === 'Own' ? '☑' : '☐'} milik sendiri /
                ${data.personal.kendaraan === 'Dinas' ? '☑' : '☐'} kendaraan dinas /
                ${data.personal.kendaraan === 'Public' ? '☑' : '☐'} kendaraan umum (${data.personal.kendaraan})
              </td>
            </tr>
          </table>
            </div>

        <!-- RIWAYAT PENDIDIKAN -->
        <div class="section">
          <div class="section-title">RIWAYAT PENDIDIKAN</div>
          
          <table>
            <thead>
              <tr>
                <th style="width: 15%;">Nama Sekolah</th>
                <th style="width: 20%;">Tempat</th>
                <th style="width: 15%;">Tahun Lulus</th>
                <th style="width: 15%;">Rata² nilai/IPK</th>
                <th style="width: 35%;">Jurusan</th>
              </tr>
            </thead>
            <tbody>
              ${data.pendidikan.map(edu => `
                <tr>
                  <td>${edu.nama}</td>
                  <td>${edu.tempat}</td>
                  <td>${edu.tahun}</td>
                  <td>${edu.nilai}</td>
                  <td>${edu.jurusan}</td>
                </tr>
              `).join('')}
            </tbody>
          </table>
          
          <div style="margin-top: 10px;">
            <div style="font-weight: bold; margin-bottom: 5px;">Kursus/Training/Seminar</div>
            <table>
            <thead>
              <tr>
                  <th style="width: 25%;">Instruktur/ Lembaga Pelaksana</th>
                  <th style="width: 20%;">Tempat</th>
                  <th style="width: 15%;">Lama Pendidikan</th>
                  <th style="width: 15%;">Yang Membiayai</th>
                  <th style="width: 25%;">Keterangan</th>
              </tr>
            </thead>
            <tbody>
                ${data.kursus.map(kursus => `
                  <tr>
                    <td>${kursus.instruktur}</td>
                    <td>${kursus.tempat}</td>
                    <td>${kursus.lama}</td>
                    <td>${kursus.biaya}</td>
                    <td>${kursus.keterangan}</td>
                </tr>
              `).join('')}
                ${Array(Math.max(0, 2 - data.kursus.length)).fill(0).map(() => `
                  <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                `).join('')}
            </tbody>
          </table>
            </div>

          <table style="margin-top: 8px;">
            <tr>
              <td class="label-cell" colspan="4">Prestasi Anda terbaik pada tingkat pendidikan</td>
            </tr>
            <tr>
              <td colspan="4">${data.prestasi.terbaik}</td>
            </tr>
            <tr>
              <td class="label-cell" colspan="4">Keterangan :</td>
            </tr>
            <tr>
              <td colspan="4">${data.prestasi.keteranganTerbaik}</td>
            </tr>
            <tr>
              <td class="label-cell" colspan="4">Prestasi Anda terendah pada tingkat pendidikan</td>
            </tr>
            <tr>
              <td colspan="4">${data.prestasi.terendah}</td>
            </tr>
            <tr>
              <td class="label-cell" colspan="4">Keterangan :</td>
            </tr>
            <tr>
              <td colspan="4">${data.prestasi.keteranganTerendah}</td>
            </tr>
            <tr>
              <td class="label-cell" colspan="4">Bahasa yang di kuasai</td>
            </tr>
            <tr>
              <td class="label-cell" style="width: 10%;">Aktif :</td>
              <td colspan="3">${data.bahasa.aktif}</td>
            </tr>
            <tr>
              <td class="label-cell">Pasif :</td>
              <td colspan="3">${data.bahasa.pasif}</td>
            </tr>
          </table>
        </div>

        <!-- Beasiswa dan Pendidikan -->
        <div class="section">
          <table>
            <tr>
              <td class="label-cell" colspan="4">Beasiswa yang pernah Anda terima :</td>
            </tr>
            <tr>
              <td colspan="4">${data.beasiswa}</td>
            </tr>
            <tr>
              <td class="label-cell" colspan="4">Siapa yang membiayai pendidikan Anda?</td>
            </tr>
            <tr>
              <td colspan="4">${data.pembiayaPendidikan}</td>
            </tr>
            <tr>
              <td class="label-cell" colspan="4">Apakah pilihan pendidikan dan pekerjaan Anda dipengaruhi oleh keluarga atau orang lain, siapa?</td>
            </tr>
            <tr>
              <td colspan="4">${data.pengaruhPilihan}</td>
            </tr>
            <tr>
              <td class="label-cell" colspan="4">Karya karya ilmiah / skripsi/artikel/buku :</td>
            </tr>
            <tr>
              <td colspan="4">${data.karyaIlmiah}</td>
            </tr>
            <tr>
              <td class="label-cell" style="width: 35%;">Rata-Rata Transkrip Nilai SMA/K/MA</td>
              <td style="width: 15%;">${data.nilaiSMA.rataRata}</td>
              <td class="label-cell" style="width: 35%;">Jumlah mata pelajaran :</td>
              <td style="width: 15%;">${data.nilaiSMA.jumlahMataPelajaran}</td>
            </tr>
            <tr>
              <td class="label-cell">Nilai Ujian SMA/K/MA</td>
              <td>${data.nilaiSMA.nilaiUjian}</td>
              <td class="label-cell">Jumlah mata pelajaran :</td>
              <td>${data.nilaiSMA.jumlahMataPelajaranUjian}</td>
            </tr>
            <tr>
              <td class="label-cell">Indeks prestasi di perguruan tinggi</td>
              <td>${data.nilaiSMA.ipk}</td>
              <td class="label-cell">Dari maksimum :</td>
              <td>${data.nilaiSMA.maksimum}</td>
            </tr>
          </table>
          </div>
        
        <!-- RIWAYAT PEKERJAAN -->
        <div class="section">
          <div class="section-title">RIWAYAT PEKERJAAN</div>
          
          <table>
              <thead>
                <tr>
                  <th style="width: 10%;">Tahun Masuk</th>
                  <th style="width: 10%;">Tahun Keluar</th>
                  <th style="width: 11%;">Jabatan</th>
                  <th style="width: 14%;">Perusahaan / Instansi</th>
                  <th style="width: 15%;">Pekerjaan</th>
                  <th style="width: 20%;">Alamat & Telp</th>
                  <th style="width: 20%;">Keterangan</th>
                </tr>
              </thead>
            <tbody>
              ${data.pekerjaan.map(work => `
                <tr>
                  <td>${work.tahunMasuk}</td>
                  <td>${work.tahunKeluar}</td>
                  <td>${work.jabatan}</td>
                  <td>${work.perusahaan}</td>
                  <td>${work.pekerjaan}</td>
                  <td>${work.alamatTelp}</td>
                  <td>${work.keterangan}</td>
                </tr>
              `).join('')}
            </tbody>
          </table>
          
          <table style="margin-top: 8px;">
            <tr>
              <td class="label-cell" colspan="4">Sebab-sebab Anda meninggalkan pekerjaan yang terakhir :</td>
            </tr>
            <tr>
              <td colspan="4">${data.alasanKeluar}</td>
            </tr>
            <tr>
              <td class="label-cell" colspan="4">Gaji/tunjangan/fasilitas / jaminan sosial yang Anda terima pada pekerjaan yang terakhir :</td>
            </tr>
            <tr>
              <td colspan="4">${data.gajiTerakhir}</td>
            </tr>
            <tr>
              <td class="label-cell" colspan="4">Pekerjaan yang paling Anda sukai di antara pengalaman pekerjaan Anda :</td>
            </tr>
            <tr>
              <td colspan="4">${data.pekerjaanFavorit}</td>
            </tr>
            <tr>
              <td class="label-cell" colspan="4">Pekerjaan yang kurang Anda sukai :</td>
            </tr>
            <tr>
              <td colspan="4">${data.pekerjaanTidakSuka}</td>
            </tr>
          </table>
            </div>
        
        <!-- AKTIVITAS SOSIAL -->
        <div class="section">
          <div class="section-title">AKTIVITAS SOSIAL</div>
          
          <table>
            <thead>
              <tr>
                <th style="width: 15%;">Tahun</th>
                <th style="width: 25%;">Jenis Aktivitas</th>
                <th style="width: 20%;">Jabatan</th>
                <th style="width: 40%;">Organisasi / Per kumpulan</th>
              </tr>
            </thead>
            <tbody>
              ${data.aktivitasSosial.map(activity => `
                <tr>
                  <td>${activity.tahun}</td>
                  <td>${activity.jenis}</td>
                  <td>${activity.jabatan}</td>
                  <td>${activity.organisasi}</td>
                </tr>
              `).join('')}
              ${Array(Math.max(0, 3 - data.aktivitasSosial.length)).fill(0).map(() => `
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              `).join('')}
            </tbody>
          </table>
          
          <table style="margin-top: 8px;">
            <tr>
              <td class="label-cell" colspan="4">Kegemaran / hobi Anda:</td>
            </tr>
            <tr>
              <td colspan="4">${data.hobi}</td>
            </tr>
            <tr>
              <td class="label-cell" colspan="4">Apakah Anda senang berolahraga? ${data.olahraga === 'Ya' ? '☑' : '☐'} Ya / ${data.olahraga === 'Tidak' ? '☑' : '☐'} Tidak (${data.olahraga})</td>
            </tr>
            <tr>
              <td class="label-cell" colspan="4">Keterangan :</td>
            </tr>
            <tr>
              <td colspan="4">${data.keteranganOlahraga}</td>
            </tr>
            <tr>
              <td class="label-cell" colspan="4">Waktu luang Anda diisi dengan</td>
            </tr>
            <tr>
              <td colspan="4">${data.waktuLuang}</td>
            </tr>
            <tr>
              <td class="label-cell" colspan="4">Anda membaca per hari: ${data.membaca === 'kurang dari 1 jam' ? '☑' : '☐'} kurang dari 1 jam / ${data.membaca === '1-3h' ? '☑' : '☐'} 1 - 3 jam / ${data.membaca === 'lebih dari 3 jam' ? '☑' : '☐'} lebih dari 3 jam (${data.membaca})</td>
            </tr>
            <tr>
              <td class="label-cell" colspan="4">Topik bacaan:</td>
            </tr>
            <tr>
              <td colspan="4">${data.topikBacaan}</td>
            </tr>
            <tr>
              <td class="label-cell" style="width: 30%;">Anda berlangganan surat kabar :</td>
              <td style="width: 20%;">${data.suratKabar}</td>
              <td class="label-cell" style="width: 30%;">Majalah:</td>
              <td style="width: 20%;">${data.majalah}</td>
            </tr>
          </table>
          </div>
          
        <!-- KELUARGA -->
        <div class="section">
          <div class="section-title">KELUARGA</div>
          
          <table>
            <tr>
              <td class="label-cell" style="width: 20%;">Tanggal pernikahan :</td>
              <td style="width: 30%;">${candidate?.family?.marriage_date || '-'}</td>
              <td class="label-cell" style="width: 20%;">Pernikahan ke :</td>
              <td style="width: 30%;">${candidate?.family?.marriage_count || '-'}</td>
            </tr>
          </table>
          
          <table style="margin-top: 8px;">
            <thead>
              <tr>
                <th style="width: 20%;">Nama</th>
                <th style="width: 8%;">L / P</th>
                <th style="width: 8%;">Usia</th>
                <th style="width: 15%;">Pendidikan Terakhir</th>
                <th style="width: 20%;">Pekerjaan</th>
                <th style="width: 29%;">Keterangan</th>
              </tr>
              <tr>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
                <th>Jabatan</th>
                <th>Perusahaan/Inst.</th>
              </tr>
            </thead>
            <tbody>
              ${candidate?.family?.members?.map(member => `
                <tr>
                  <td>${member.nama || '-'}</td>
                  <td>${member.gender || '-'}</td>
                  <td>${member.usia || '-'}</td>
                  <td>${member.pendidikan_terakhir || '-'}</td>
                  <td>${member.jabatan || member.pekerjaan || '-'}</td>
                  <td>${member.perusahaan || member.keterangan || '-'}</td>
                </tr>
              `).join('') || `
                <tr>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                </tr>
              `}
              ${candidate?.family?.members?.length > 0 ? '' : Array(4).fill(0).map(() => `
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              `).join('')}
              <tr>
                <td colspan="6" style="font-size: 8px;">Bila masih ada saudara yang belum tercantum, berapa jumlahnya? <span style="border-bottom: 1px solid #000; display: inline-block; min-width: 50px;">-</span></td>
              </tr>
            </tbody>
          </table>
            </div>

        <!-- LAMARAN DAN KETERAMPILAN -->
        <div class="section">
          <div class="section-title">LAMARAN DAN KETERAMPILAN</div>
          
            <table>
            <tr>
              <td class="label-cell" colspan="4">Tujuan / Alasan Anda melamar :</td>
            </tr>
            <tr>
              <td colspan="4">${candidate?.applicationSkills?.apply_reason || '-'}</td>
            </tr>
            <tr>
              <td class="label-cell" colspan="4">Tindakan Anda atas saran : ☐ orang tua / ☐ teman / ☐ Saudara / ☐ iklan</td>
            </tr>
            <tr>
              <td class="label-cell" colspan="4">Keterangan :</td>
            </tr>
            <tr>
              <td colspan="4">${candidate?.applicationSkills?.apply_initiator_note || '-'}</td>
            </tr>
            <tr>
              <td class="label-cell" colspan="4">Jabatan yang Anda inginkan :</td>
            </tr>
            <tr>
              <td colspan="4">${candidate?.applicationSkills?.desired_position || '-'}</td>
            </tr>
            <tr>
              <td class="label-cell" colspan="4">Gaji yang diharapkan :</td>
            </tr>
            <tr>
              <td colspan="4">Rp ${candidate?.applicationSkills?.expected_salary ? parseInt(candidate.applicationSkills.expected_salary).toLocaleString('id-ID') : '-'}</td>
            </tr>
            <tr>
              <td class="label-cell" colspan="4">Tunjangan dan fasilitas yang Anda harapkan :</td>
            </tr>
            <tr>
              <td colspan="4">${candidate?.applicationSkills?.expected_benefits || '-'}</td>
            </tr>
            <tr>
              <td class="label-cell" colspan="4">Tugas / pekerjaan yang Anda kuasai dengan baik :</td>
            </tr>
            <tr>
              <td colspan="4">${candidate?.applicationSkills?.skills || '-'}</td>
            </tr>
          </table>
          
          <table style="margin-top: 8px;">
              <tbody>
                <tr>
                <td style="width: 60%; font-weight: bold;" class="label-cell">Apakah Anda bersedia mengikuti pemeriksaan medis lengkap :</td>
                  <td style="width: 20%; text-align: center;">${candidate?.applicationSkills?.willing_medical ? '☑' : '☐'} Ya</td>
                  <td style="width: 20%; text-align: center;">${!candidate?.applicationSkills?.willing_medical ? '☑' : '☐'} Tidak</td>
              </tr>
                <tr>
                <td class="label-cell">Apakah Anda bersedia mengikuti pemeriksaan psikologi?</td>
                  <td style="text-align: center;">${candidate?.applicationSkills?.willing_psychology ? '☑' : '☐'} Ya</td>
                  <td style="text-align: center;">${!candidate?.applicationSkills?.willing_psychology ? '☑' : '☐'} Tidak</td>
                </tr>
                <tr>
                <td class="label-cell">Apakah Anda bersedia ditugaskan ke luar kota?</td>
                  <td style="text-align: center;">${candidate?.applicationSkills?.willing_relocate ? '☑' : '☐'} Ya</td>
                  <td style="text-align: center;">${!candidate?.applicationSkills?.willing_relocate ? '☑' : '☐'} Tidak</td>
                </tr>
                <tr>
                <td class="label-cell">Apakah Anda bersedia menjalani masa percobaan 3 bulan ?</td>
                  <td style="text-align: center;">${candidate?.applicationSkills?.willing_trial ? '☑' : '☐'} Ya</td>
                  <td style="text-align: center;">${!candidate?.applicationSkills?.willing_trial ? '☑' : '☐'} Tidak</td>
                </tr>
                <tr>
                <td class="label-cell">Apakah Anda bersedia dipindahkan ke luar kota?</td>
                  <td style="text-align: center;">${candidate?.applicationSkills?.willing_transfer ? '☑' : '☐'} Ya</td>
                  <td style="text-align: center;">${!candidate?.applicationSkills?.willing_transfer ? '☑' : '☐'} Tidak</td>
                </tr>
                <tr>
                <td class="label-cell">Apakah Anda bersedia mentaati peraturan dan tata tertib serta ketentuan-ketentuan kerja yang telah dan akan ditetapkan</td>
                  <td style="text-align: center;">${candidate?.applicationSkills?.willing_rules ? '☑' : '☐'} Ya</td>
                  <td style="text-align: center;">${!candidate?.applicationSkills?.willing_rules ? '☑' : '☐'} Tidak</td>
                </tr>
            </tbody>
          </table>
          
          <table style="margin-top: 8px;">
            <tr>
              <td class="label-cell" colspan="4">Anda dapat menggunakan dan mengoperasikan komputer: ${candidate?.applicationSkills?.computer_skill ? '☑' : '☐'} Ya / ${!candidate?.applicationSkills?.computer_skill ? '☑' : '☐'} Tidak (${candidate?.applicationSkills?.computer_skill ? 'Ya' : 'Tidak'})</td>
            </tr>
            <tr>
              <td class="label-cell" colspan="4">Program yang Anda kuasai :</td>
            </tr>
            <tr>
              <td colspan="4">${candidate?.applicationSkills?.computer_programs || '-'}</td>
            </tr>
            <tr>
              <td class="label-cell" colspan="4">Anda dapat mengetik dalam bahasa Indonesia/Inggris: ${candidate?.applicationSkills?.typing_level === 'Beginner' ? '☑' : '☐'} bisa / ${candidate?.applicationSkills?.typing_level === 'Intermediate' ? '☑' : '☐'} sedang / ${candidate?.applicationSkills?.typing_level === 'Expert' ? '☑' : '☐'} lancar (${candidate?.applicationSkills?.typing_level || '-'})</td>
            </tr>
            <tr>
              <td class="label-cell" colspan="4">Anda dapat mengendarai: ${candidate?.applicationSkills?.driving_ability?.includes('Motor') ? '☑' : '☐'} sepeda motor / ${candidate?.applicationSkills?.driving_ability?.includes('Mobil') ? '☑' : '☐'} mobil / ${candidate?.applicationSkills?.driving_ability?.includes('Lainnya') ? '☑' : '☐'} lainnya (${candidate?.applicationSkills?.driving_ability || '-'})</td>
            </tr>
          </table>
          
          <table style="margin-top: 8px;">
            <thead>
              <tr>
                <th colspan="9" style="text-align: left; font-weight: bold;" class="label-cell">Anda memiliki SIM?</th>
              </tr>
              <tr>
                <th style="width: 10%;">C</th>
                <th style="width: 13%;">No.</th>
                <th style="width: 13%;">Masa<br>berlaku</th>
                <th style="width: 10%;">A</th>
                <th style="width: 13%;">No.</th>
                <th style="width: 13%;">Masa<br>berlaku</th>
                <th style="width: 10%;">B</th>
                <th style="width: 13%;">No.</th>
                <th style="width: 13%;">Masa<br>berlaku</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style="text-align: center;">${candidate?.applicationSkills?.driving_ability?.includes('Motor') ? '☑' : '☐'}</td>
                <td>${candidate?.applicationSkills?.driving_ability?.includes('Motor') ? 'SIM C' : '-'}</td>
                <td>${candidate?.applicationSkills?.driving_ability?.includes('Motor') ? 'Valid' : '-'}</td>
                <td style="text-align: center;">${candidate?.applicationSkills?.driving_ability?.includes('Mobil') ? '☑' : '☐'}</td>
                <td>${candidate?.applicationSkills?.driving_ability?.includes('Mobil') ? 'SIM A' : '-'}</td>
                <td>${candidate?.applicationSkills?.driving_ability?.includes('Mobil') ? 'Valid' : '-'}</td>
                <td style="text-align: center;">☐</td>
                <td>-</td>
                <td>-</td>
                </tr>
            </tbody>
          </table>
          
          <table style="margin-top: 8px;">
            <tr>
              <td class="label-cell" colspan="4">Apakah Anda mengerti seluk-beluk motor bensin / diesel dan pelistrikan? ${candidate?.applicationSkills?.vehicle_knowledge ? '☑' : '☐'} Ya / ${!candidate?.applicationSkills?.vehicle_knowledge ? '☑' : '☐'} Tidak (${candidate?.applicationSkills?.vehicle_knowledge ? 'Ya' : 'Tidak'})</td>
            </tr>
          </table>
            </div>

        <!-- UMUM DAN KESEHATAN -->
        <div class="section">
          <div class="section-title">UMUM DAN KESEHATAN</div>
          
          <table>
            <tr>
              <td class="label-cell" colspan="4">Apakah Anda pernah diberhentikan dari pekerjaan karena prestasi yang kurang baik? ${candidate?.generalHealth?.ever_fired ? '☑' : '☐'} Ya / ${!candidate?.generalHealth?.ever_fired ? '☑' : '☐'} Tidak (${candidate?.generalHealth?.ever_fired ? 'Ya' : 'Tidak'})</td>
            </tr>
            <tr>
              <td class="label-cell" colspan="4">Bila menghadapi persoalan pekerjaan dan harus mengambil keputusan, Anda akan meminta nasihat kepada : atasan / teman sekerja / Jelaskan :</td>
            </tr>
            <tr>
              <td colspan="4">${candidate?.generalHealth?.work_advice_source || '-'}</td>
            </tr>
            <tr>
              <td class="label-cell" colspan="4">Dalam menghadapi persoalan pribadi Anda meminta nasihat :</td>
            </tr>
            <tr>
              <td colspan="4">${candidate?.generalHealth?.personal_advice_source || '-'}</td>
            </tr>
            <tr>
              <td class="label-cell" colspan="4">jelaskan :</td>
            </tr>
            <tr>
              <td colspan="4">${candidate?.generalHealth?.personal_advice_note || '-'}</td>
            </tr>
            <tr>
              <td class="label-cell" colspan="4">Reaksi Anda apabila ditegur oleh atasan karena membuat kesalahan dalam pekerjaan :</td>
            </tr>
            <tr>
              <td colspan="4">${candidate?.generalHealth?.reaction_to_criticism || '-'}</td>
            </tr>
            <tr>
              <td class="label-cell" colspan="4">Sakit apakah yang sering Anda alami?</td>
            </tr>
            <tr>
              <td colspan="4">${candidate?.generalHealth?.common_illness || '-'}</td>
            </tr>
            <tr>
              <td class="label-cell" colspan="4">Pernah sakit keras sehingga perlu perawatan khusus? ${candidate?.generalHealth?.serious_illness ? '☑' : '☐'} Ya / ${!candidate?.generalHealth?.serious_illness ? '☑' : '☐'} Tidak (${candidate?.generalHealth?.serious_illness ? 'Ya' : 'Tidak'})</td>
            </tr>
            <tr>
              <td class="label-cell" colspan="4">Jelaskan •</td>
            </tr>
            <tr>
              <td colspan="4">${candidate?.generalHealth?.serious_illness_desc || '-'}</td>
            </tr>
            <tr>
              <td class="label-cell" colspan="4">Apakah Anda menderita / pernah menderita :</td>
            </tr>
          </table>
          
          <table style="margin-top: 8px;">
            <tr>
              <td class="label-cell" style="width: 25%;">Penyakit mata</td>
              <td style="width: 25%;">${candidate?.generalHealth?.eye_disease ? '☑' : '☐'} Ya / ${!candidate?.generalHealth?.eye_disease ? '☑' : '☐'} Tidak (${candidate?.generalHealth?.eye_disease ? 'Ya' : 'Tidak'})</td>
              <td class="label-cell" style="width: 25%;">Penyakit paru-paru</td>
              <td style="width: 25%;">${candidate?.generalHealth?.lung_disease ? '☑' : '☐'} Ya / ${!candidate?.generalHealth?.lung_disease ? '☑' : '☐'} Tidak (${candidate?.generalHealth?.lung_disease ? 'Ya' : 'Tidak'})</td>
            </tr>
            <tr>
              <td class="label-cell">Penyakit telinga</td>
              <td>${candidate?.generalHealth?.ear_disease ? '☑' : '☐'} Ya / ${!candidate?.generalHealth?.ear_disease ? '☑' : '☐'} Tidak (${candidate?.generalHealth?.ear_disease ? 'Ya' : 'Tidak'})</td>
              <td class="label-cell">Penyakit gula</td>
              <td>${candidate?.generalHealth?.diabetes ? '☑' : '☐'} Ya / ${!candidate?.generalHealth?.diabetes ? '☑' : '☐'} Tidak (${candidate?.generalHealth?.diabetes ? 'Ya' : 'Tidak'})</td>
            </tr>
            <tr>
              <td class="label-cell">Penyakit darah tinggi</td>
              <td>${candidate?.generalHealth?.hypertension ? '☑' : '☐'} Ya / ${!candidate?.generalHealth?.hypertension ? '☑' : '☐'} Tidak (${candidate?.generalHealth?.hypertension ? 'Ya' : 'Tidak'})</td>
              <td class="label-cell">Penyakit jantung</td>
              <td>${candidate?.generalHealth?.heart_disease ? '☑' : '☐'} Ya / ${!candidate?.generalHealth?.heart_disease ? '☑' : '☐'} Tidak (${candidate?.generalHealth?.heart_disease ? 'Ya' : 'Tidak'})</td>
            </tr>
            <tr>
              <td class="label-cell" colspan="2">General check up terakhir (bulan/tahun)</td>
              <td colspan="2">${candidate?.generalHealth?.last_checkup ? new Date(candidate.generalHealth.last_checkup).toLocaleDateString('id-ID', { month: 'long', year: 'numeric' }) : '-'}</td>
            </tr>
          </table>
            </div>
        
        <!-- LAIN - LAIN -->
        <div class="section">
          <div class="section-title">LAIN - LAIN</div>
          
          <table>
            <tr>
              <td class="label-cell" colspan="6">Alamat relasi atau keluarga terdekat yang mudah dihubungi bila Anda berhalangan atau mengalami kecelakaan.</td>
            </tr>
          </table>
          
          <table style="margin-top: 8px;">
            <thead>
              <tr>
                <th style="width: 20%;">Nama</th>
                <th style="width: 8%;">Usia</th>
                <th style="width: 25%;">Alamat Rumah / Kantor</th>
                <th style="width: 15%;">No. Telepon</th>
                <th style="width: 12%;">Hubungan</th>
                <th style="width: 20%;">Keterangan</th>
              </tr>
            </thead>
            <tbody>
              ${candidate?.others?.emergency_relations?.map(relation => `
                <tr>
                  <td>${relation.nama || '-'}</td>
                  <td>${relation.usia || '-'}</td>
                  <td>${relation.alamat || '-'}</td>
                  <td>${relation.no_telepon || '-'}</td>
                  <td>${relation.hubungan || '-'}</td>
                  <td>${relation.keterangan || '-'}</td>
                </tr>
              `).join('') || `
                <tr>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                </tr>
              `}
              ${candidate?.others?.emergency_relations?.length > 0 ? '' : Array(2).fill(0).map(() => `
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              `).join('')}
            </tbody>
          </table>
          
          <table style="margin-top: 8px;">
            <tr>
              <td class="label-cell" colspan="6">Keluarga /eks atasan/teman yang dapat dihubungi dan diminta memberikan keterangan tentang Anda.</td>
            </tr>
          </table>
            
          <table style="margin-top: 8px;">
                <thead>
                  <tr>
                <th style="width: 20%;">Nama</th>
                <th style="width: 8%;">Usia</th>
                <th style="width: 25%;">Alamat Rumah / Kantor</th>
                <th style="width: 15%;">No. Telepon</th>
                <th style="width: 12%;">Hubungan</th>
                <th style="width: 20%;">Keterangan</th>
                  </tr>
                </thead>
                <tbody>
              ${candidate?.others?.former_relations?.map(relation => `
                <tr>
                  <td>${relation.nama || '-'}</td>
                  <td>${relation.usia || '-'}</td>
                  <td>${relation.alamat || '-'}</td>
                  <td>${relation.no_telepon || '-'}</td>
                  <td>${relation.hubungan || '-'}</td>
                  <td>${relation.keterangan || '-'}</td>
                </tr>
              `).join('') || `
                <tr>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                </tr>
              `}
                  ${candidate?.others?.former_relations?.length > 0 ? '' : Array(1).fill(0).map(() => `
                    <tr>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                  `).join('')}
                </tbody>
              </table>
          
          <table style="margin-top: 8px;">
            <tr>
              <td class="label-cell" colspan="6">Sebutkan kelebihan Anda yang kiranya dapat mendukung keberhasilan Anda pada pekerjaan:</td>
            </tr>
            <tr>
              <td colspan="6">${candidate?.generalHealth?.strength || '-'}</td>
            </tr>
            <tr>
              <td class="label-cell" colspan="6">Sebutkan kekurangan Anda yang perlu diperhatikan untuk keberhasilan Anda pada pekerjaan:</td>
            </tr>
            <tr>
              <td colspan="6">${candidate?.generalHealth?.weakness || '-'}</td>
            </tr>
            <tr>
              <td class="label-cell" colspan="6">Apakah Anda bersedia menyerahkan ijazah Terakhir Asli apabila diperlukan sebagai jaminan? ${candidate?.generalHealth?.willing_original_certificate ? '☑' : '☐'} Ya / ${!candidate?.generalHealth?.willing_original_certificate ? '☑' : '☐'} Tidak (${candidate?.generalHealth?.willing_original_certificate ? 'Ya' : 'Tidak'})</td>
            </tr>
          </table>
          
          <table style="margin-top: 8px;">
            <tr>
              <td class="label-cell" colspan="6">Siapa yang menjadi penjamin Anda bekerja di PT. Eureka Group?</td>
            </tr>
          </table>
          
          <table style="margin-top: 8px;">
                <thead>
                  <tr>
                <th style="width: 20%;">Nama</th>
                <th style="width: 8%;">Usia</th>
                <th style="width: 25%;">Rumah / Kantor</th>
                <th style="width: 15%;">No. Telepon</th>
                <th style="width: 12%;">Hubungan</th>
                <th style="width: 20%;">Keterangan</th>
                  </tr>
                </thead>
                <tbody>
              ${candidate?.others?.guarantors?.map(guarantor => `
                <tr>
                  <td>${guarantor.nama || '-'}</td>
                  <td>${guarantor.usia || '-'}</td>
                  <td>${guarantor.alamat || '-'}</td>
                  <td>${guarantor.no_telepon || '-'}</td>
                  <td>${guarantor.hubungan || '-'}</td>
                  <td>${guarantor.keterangan || '-'}</td>
                </tr>
              `).join('') || `
                <tr>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                  <td>-</td>
                </tr>
              `}
              ${candidate?.others?.guarantors?.length > 0 ? '' : Array(1).fill(0).map(() => `
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                    </tr>
                  `).join('')}
                </tbody>
              </table>
          
          <table style="margin-top: 20px;">
            <tr>
              <td colspan="6" style="text-align: center; font-size: 9px; padding: 10px;">
              <strong>Keterangan diatas 'saya buat sesuai dengan keadaan yang sebenamya dan apabila tidak benar atau tidak jujur saya bersedia berhenti seketika dari perusahaan.</strong>
              </td>
            </tr>
            <tr>
              <td colspan="3"></td>
              <td colspan="1" style="text-align: center; padding: 30px 10px 5px;">_______________________</td>
              <td colspan="2" style="text-align: center; padding: 30px 10px 5px;">______________</td>
            </tr>
            <tr>
              <td colspan="3"></td>
              <td colspan="1" style="text-align: center; font-size: 8px;">(Tanda Tangan)</td>
              <td colspan="2" style="text-align: center; font-size: 8px;">(Tanggal)</td>
            </tr>
              </table>
            </div>
        
      </div>
    </body>
    </html>
  `;
};

export const openPrintPreview = (htmlContent) => {
  // Create a new tab instead of a window
  const printTab = window.open('', '_blank');
  printTab.document.write(htmlContent);
  printTab.document.close();
  
  // Wait for content to load, then trigger print dialog
  printTab.onload = () => {
    setTimeout(() => {
      printTab.print();
    }, 1000);
  };
};

// Generate form-style print HTML for Employee
export const generateEmployeeFormPrintHTML = (employee) => {
  const formatDate = (dateString) => {
    if (!dateString) return '-';
    return new Date(dateString).toLocaleDateString('id-ID', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    });
  };

  const formatDateShort = (dateString) => {
    if (!dateString) return '-';
    return new Date(dateString).toLocaleDateString('en-GB');
  };

  const formatGender = (sex) => {
    if (sex === 'Male') return 'Laki-laki';
    if (sex === 'Female') return 'Perempuan';
    return sex || '-';
  };

  const formatCurrency = (amount) => {
    if (!amount) return '-';
    const numericAmount = amount.toString().replace(/\./g, '');
    return `Rp ${parseInt(numericAmount).toLocaleString('id-ID')}`;
  };

  const formatFamilyType = (type) => {
    if (type === 'Child') return 'Anak';
    if (type === 'Spouse') return 'Istri/Suami';
    if (type === 'Father') return 'Ayah';
    if (type === 'Mother') return 'Ibu';
    return type || '-';
  };

  const formatGenderShort = (gender) => {
    if (gender === 'L' || gender === 'Male') return 'L';
    if (gender === 'P' || gender === 'Female') return 'P';
    return gender || '-';
  };

  return `
    <!DOCTYPE html>
    <html lang="id">
    <head>
      <meta charset="UTF-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <title>Formulir Data Karyawan - ${employee.full_name}</title>
      <style>
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }
        
        body {
          font-family: Arial, sans-serif;
          line-height: 1.3;
          color: #000;
          background: white;
          font-size: 10px;
          margin: 0;
          padding: 0;
        }
        
        .form-container {
          max-width: 210mm;
          margin: 0 auto;
          padding: 10mm;
          background: white;
          min-height: 100vh;
        }
        
        .header {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          margin-bottom: 20px;
          border-bottom: 2px solid #000;
          padding-bottom: 10px;
        }
        
        .logo-section {
          flex: 1;
        }
        
        .company-name {
          font-size: 14px;
          font-weight: bold;
          margin-bottom: 5px;
        }
        
        .company-info {
          font-size: 10px;
          line-height: 1.3;
        }
        
        .photo-placeholder {
          width: 60px;
          height: 80px;
          border: 2px solid #000;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 8px;
          text-align: center;
          margin-left: 20px;
        }
        
        .form-title {
          text-align: center;
          font-size: 16px;
          font-weight: bold;
          margin: 10px 0 5px 0;
          text-decoration: underline;
        }
        
        .instruction {
          text-align: center;
          font-size: 10px;
          font-style: italic;
          margin-bottom: 10px;
        }
        
        .section {
          margin-bottom: 12px;
          margin-top: 5px;
        }
        
        .section-title {
          font-size: 14px;
          font-weight: bold;
          margin-bottom: 6px;
          text-decoration: underline;
        }
        
        .form-row {
          display: flex;
          margin-bottom: 4px;
          align-items: center;
        }
        
        .form-label {
          width: 200px;
          font-weight: bold;
          flex-shrink: 0;
        }
        
        .form-value {
          flex: 1;
          border-bottom: 1px solid #000;
          min-height: 16px;
          padding: 2px 5px;
        }
        
        .form-value-inline {
          display: inline-block;
          border-bottom: 1px solid #000;
          min-width: 100px;
          min-height: 16px;
          padding: 2px 5px;
          margin-right: 20px;
        }
        
        .checkbox-group {
          display: flex;
          gap: 15px;
          margin-left: 10px;
        }
        
        .checkbox-item {
          display: flex;
          align-items: center;
          gap: 5px;
        }
        
        .checkbox {
          width: 12px;
          height: 12px;
          border: 1px solid #000;
          display: inline-block;
        }
        
        .table {
          width: 100%;
          border-collapse: collapse;
          margin-top: 6px;
        }
        
        .table th,
        .table td {
          border: 1px solid #000;
          padding: 4px;
          text-align: left;
          font-size: 9px;
        }
        
        .table th {
          background-color: #f0f0f0;
          font-weight: bold;
          text-align: center;
          padding: 5px 4px;
        }
        
        .table td {
          vertical-align: top;
        }
        
        .label-cell {
          font-weight: bold;
          background-color: #f5f5f5;
        }
        
        .two-column {
          display: flex;
          gap: 20px;
        }
        
        .column {
          flex: 1;
        }
        
        @media print {
          body { -webkit-print-color-adjust: exact; }
          .form-container { padding: 10mm; }
        }
      </style>
    </head>
    <body>
      <div class="form-container">
        <!-- Header -->
        <div class="header">
          <div class="logo-section">
            <img src="${window.location.origin}/src/assets/images/eurekalogo.png" alt="eureka!" style="height: 35px; margin-bottom: 4px;" />
            <div class="company-info">
              Jl. H. Baping No. 100, Susukan, Ciracas, Kota Jakarta Timur, DKI Jakarta 13740<br>
              Email: info@eurekagroup.id
            </div>
          </div>
          <div class="photo-placeholder">
            Foto 4 x 6
          </div>
        </div>
        
        <div class="form-title">FORMULIR DATA KARYAWAN</div>
        <div class="instruction">(Harap ditulis dengan huruf balok)</div>
        
        <!-- IDENTITAS -->
        <div class="section">
          <div class="section-title">IDENTITAS</div>
          
          <table class="table">
            <tr>
              <td class="label-cell" style="width: 25%;">Nama</td>
              <td colspan="3" style="width: 75%;">${employee.full_name || employee.staticData?.personalData?.employee_name || '(Belum diisi)'}</td>
            </tr>
            <tr>
              <td class="label-cell" style="width: 25%;">Laki-laki / Perempuan</td>
              <td style="width: 25%;">${employee.sex ? formatGender(employee.sex) : (employee.staticData?.personalData?.gender ? formatGender(employee.staticData.personalData.gender === 'L' ? 'Male' : 'Female') : '(Belum diisi)')}</td>
              <td class="label-cell" style="width: 25%;">Usia</td>
              <td style="width: 25%;">${employee.age || employee.staticData?.personalData?.age || '(Belum diisi)'} ${(employee.age || employee.staticData?.personalData?.age) ? 'tahun' : ''}</td>
            </tr>
            <tr>
              <td class="label-cell">Tempat / Tanggal lahir</td>
              <td>${employee.birth_place || employee.staticData?.personalData?.birth_place || '(Belum diisi)'}, ${formatDate(employee.birth_date || employee.staticData?.personalData?.birth_date)}</td>
              <td class="label-cell">Agama</td>
              <td>${employee.religion || employee.staticData?.personalData?.religion || '(Belum diisi)'}</td>
            </tr>
            <tr>
              <td class="label-cell">Suku bangsa</td>
              <td>${employee.ethnicity || employee.staticData?.personalData?.ethnicity || '(Belum diisi)'}</td>
              <td class="label-cell">Tinggi badan</td>
              <td>${employee.height_cm || employee.staticData?.personalData?.height_cm || '(Belum diisi)'} ${(employee.height_cm || employee.staticData?.personalData?.height_cm) ? 'cm' : ''}</td>
            </tr>
            <tr>
              <td class="label-cell">Berat badan</td>
              <td colspan="3">${employee.weight_kg || employee.staticData?.personalData?.weight_kg || '(Belum diisi)'} ${(employee.weight_kg || employee.staticData?.personalData?.weight_kg) ? 'kg' : ''}</td>
            </tr>
            <tr>
              <td class="label-cell">Alamat Lengkap & Telp</td>
              <td colspan="3">${employee.address || employee.staticData?.address?.street || '(Belum diisi)'} — ${employee.no_telp || employee.staticData?.contact?.mobile_phone || '(Belum diisi)'}</td>
            </tr>
            <tr>
              <td class="label-cell">No. KTP</td>
              <td>${employee.id_number || employee.staticData?.personalData?.id_number || '(Belum diisi)'}</td>
              <td class="label-cell">Daerah</td>
              <td>${employee.region || employee.staticData?.address?.subdistrict || employee.staticData?.address?.city || '(Belum diisi)'}</td>
            </tr>
            <tr>
              <td class="label-cell">Masa berlaku</td>
              <td colspan="3">${employee.id_expiry_date || employee.staticData?.personalData?.id_expiry_date || 'Seumur hidup'}</td>
            </tr>
            <tr>
              <td class="label-cell">Email</td>
              <td colspan="3">${employee.email || employee.staticData?.contact?.corporate_email || '(Belum diisi)'}</td>
            </tr>
            <tr>
              <td class="label-cell">Status Pernikahan</td>
              <td>${employee.marital_status || employee.staticData?.personalData?.marital_status || '(Belum diisi)'}</td>
              <td class="label-cell">Tanggal Menikah</td>
              <td>${(employee.marital_date || employee.staticData?.personalData?.marital_date) ? formatDate(employee.marital_date || employee.staticData?.personalData?.marital_date) : '(Belum diisi)'}</td>
            </tr>
            <tr>
              <td class="label-cell">Nama Ibu Kandung</td>
              <td colspan="3">${employee.mother_maiden_name || employee.staticData?.personalData?.mother_maiden_name || '(Belum diisi)'}</td>
            </tr>
            <tr>
              <td class="label-cell">Saat ini tinggal di rumah</td>
              <td colspan="3">
                ${employee.living_status || employee.staticData?.personalData?.living_status || '☐ dinas / ☐ orang tua / ☐ sewa / ☐ indekos / ☐ sendiri / ☐ menumpang'}
              </td>
            </tr>
            <tr>
              <td class="label-cell">Kendaraan yang Anda pergunakan jenis</td>
              <td colspan="3">
                ${employee.driving_ability || employee.staticData?.applicationSkills?.driving_ability || '(Belum diisi)'} — ${employee.vehicle_ownership || employee.staticData?.personalData?.vehicle_ownership || '☐ milik sendiri / ☐ kendaraan dinas / ☐ kendaraan umum'}
              </td>
            </tr>
          </table>
        </div>
        
        <!-- RIWAYAT PENDIDIKAN -->
        <div class="section">
          <div class="section-title">RIWAYAT PENDIDIKAN</div>
          
          <table class="table">
            <thead>
              <tr>
                <th style="width: 10%;">Jenjang</th>
                <th style="width: 25%;">Nama Sekolah</th>
                <th style="width: 15%;">Tempat</th>
                <th style="width: 12%;">Tahun Lulus</th>
                <th style="width: 15%;">Rata2 nilai/IPK</th>
                <th style="width: 23%;">Jurusan</th>
              </tr>
            </thead>
            <tbody>
              ${((employee.education_data || employee.staticData?.education) && (employee.education_data?.length > 0 || employee.staticData?.education?.length > 0)) ? (employee.education_data || employee.staticData?.education || []).map(edu => `
                <tr>
                  <td>${edu.level || '(Belum diisi)'}</td>
                  <td>${edu.school_name || '(Belum diisi)'}</td>
                  <td>${edu.location || '(Belum diisi)'}</td>
                  <td>${edu.graduation_year || '(Belum diisi)'}</td>
                  <td>${edu.gpa || '(Belum diisi)'}</td>
                  <td>${edu.major || '(Belum diisi)'}</td>
                </tr>
              `).join('') : `
                <tr>
                  <td colspan="6" style="text-align: center; padding: 20px; color: #999; font-style: italic;">(Belum ada data pendidikan)</td>
                </tr>
              `}
            </tbody>
          </table>
        </div>
        
        <!-- KURSUS / Training / Lokakarya -->
        <div class="section">
          <div class="section-title">KURSUS / Training / Lokakarya</div>
          
          <table class="table">
            <thead>
              <tr>
                <th style="width: 22%;">Instruktur / Lembaga Pelaksana</th>
                <th style="width: 15%;">Tempat</th>
                <th style="width: 15%;">Lama Pendidikan</th>
                <th style="width: 18%;">Yang Membiayai</th>
                <th style="width: 30%;">Keterangan</th>
              </tr>
            </thead>
            <tbody>
              ${((employee.courses_data || employee.staticData?.courses) && (employee.courses_data?.length > 0 || employee.staticData?.courses?.length > 0)) ? (employee.courses_data || employee.staticData?.courses || []).map(course => `
                <tr>
                  <td>${course.instructor_institution || '(Belum diisi)'}</td>
                  <td>${course.location || '(Belum diisi)'}</td>
                  <td>${course.duration || '(Belum diisi)'}</td>
                  <td>${course.funded_by || '(Belum diisi)'}</td>
                  <td>${course.notes || '(Belum diisi)'}</td>
                </tr>
              `).join('') : `
                <tr>
                  <td colspan="5" style="text-align: center; padding: 20px; color: #999; font-style: italic;">(Belum ada data kursus/training)</td>
                </tr>
              `}
            </tbody>
          </table>
        </div>
        
        <!-- RIWAYAT PEKERJAAN -->
        <div class="section">
          <div class="section-title">RIWAYAT PEKERJAAN</div>
          
          <table class="table">
            <thead>
              <tr>
                <th style="width: 10%;">Masuk</th>
                <th style="width: 10%;">Keluar</th>
                <th style="width: 18%;">Jabatan</th>
                <th style="width: 20%;">Perusahaan / Instansi</th>
                <th style="width: 22%;">Alamat & Telp</th>
                <th style="width: 20%;">Keterangan</th>
              </tr>
            </thead>
            <tbody>
              ${((employee.work_history_data || employee.staticData?.work_history) && (employee.work_history_data?.length > 0 || employee.staticData?.work_history?.length > 0)) ? (employee.work_history_data || employee.staticData?.work_history || []).map(work => `
                <tr>
                  <td>${work.entry_date ? new Date(work.entry_date).getFullYear() : '(Belum diisi)'}</td>
                  <td>${work.exit_date ? new Date(work.exit_date).getFullYear() : '(Belum diisi)'}</td>
                  <td>${work.position || '(Belum diisi)'}</td>
                  <td>${work.company || '(Belum diisi)'}</td>
                  <td>${work.address_phone || '(Belum diisi)'}</td>
                  <td>${work.notes || '(Belum diisi)'}</td>
                </tr>
              `).join('') : `
                <tr>
                  <td colspan="6" style="text-align: center; padding: 20px; color: #999; font-style: italic;">(Belum ada data riwayat pekerjaan)</td>
                </tr>
              `}
            </tbody>
          </table>
          
          <table class="table" style="margin-top: 10px;">
            <tr>
              <td class="label-cell" style="width: 50%;">Sebab-sebab Anda meninggalkan pekerjaan yang terakhir</td>
              <td style="width: 50%;">${employee.last_job_reason_leave || employee.staticData?.history?.last_job_reason_leave || '(Belum diisi)'}</td>
            </tr>
            <tr>
              <td class="label-cell">Gaji / tunjangan / fasilitas / jaminan sosial pada pekerjaan terakhir</td>
              <td>${(employee.last_job_salary || employee.staticData?.history?.last_job_salary) ? formatCurrency(employee.last_job_salary || employee.staticData?.history?.last_job_salary) : '(Belum diisi)'}</td>
            </tr>
            <tr>
              <td class="label-cell">Pekerjaan yang paling Anda sukai</td>
              <td>${employee.job_most_liked || employee.staticData?.history?.job_most_liked || '(Belum diisi)'}</td>
            </tr>
            <tr>
              <td class="label-cell">Pekerjaan yang kurang Anda sukai</td>
              <td>${employee.job_least_liked || employee.staticData?.history?.job_least_liked || '(Belum diisi)'}</td>
            </tr>
            <tr>
              <td class="label-cell">Hobi</td>
              <td>${employee.hobby || employee.staticData?.history?.hobby || '(Belum diisi)'}</td>
            </tr>
            <tr>
              <td class="label-cell">Olahraga</td>
              <td>${employee.sport || employee.staticData?.history?.sport || '(Belum diisi)'}</td>
            </tr>
          </table>
          </div>
          
        <!-- KELUARGA -->
        ${((employee.family_data || employee.staticData?.family) && (employee.family_data?.length > 0 || employee.staticData?.family?.length > 0)) ? `
        <div class="section" style="page-break-before: always;">
          <div class="section-title">KELUARGA</div>
          
          <div style="margin-bottom: 10px;">
            <strong>Status Pernikahan:</strong> ${employee.marital_status || employee.staticData?.personalData?.marital_status || '-'}
          </div>
          
          <table class="table">
            <thead>
              <tr>
                <th style="width: 15%;">Jenis</th>
                <th style="width: 30%;">Nama</th>
                <th style="width: 10%;">L/P</th>
                <th style="width: 10%;">Usia</th>
                <th style="width: 35%;">Pekerjaan</th>
              </tr>
            </thead>
            <tbody>
              ${(employee.family_data || employee.staticData?.family || []).map(member => `
                <tr>
                  <td>${formatFamilyType(member.type)}</td>
                  <td>${member.name || '(Belum diisi)'}</td>
                  <td>${member.gender ? formatGenderShort(member.gender) : '(Belum diisi)'}</td>
                  <td>${member.age || '(Belum diisi)'}</td>
                  <td>${member.job || '(Belum diisi)'}</td>
                </tr>
              `).join('')}
            </tbody>
          </table>
          </div>
        ` : ''}
        
        <!-- INFORMASI PEKERJAAN -->
        <div class="section">
          <div class="section-title">INFORMASI PEKERJAAN</div>
          
          <table class="table">
            <tr>
              <td class="label-cell" style="width: 20%;">Kantor</td>
              <td style="width: 30%;">${employee.id_office?.office_name || employee.staticData?.address?.location_id || '(Belum diisi)'}</td>
              <td class="label-cell" style="width: 20%;">Unit Bisnis</td>
              <td style="width: 30%;">${employee.id_bu?.bu_name || employee.staticData?.workInfo?.business_unit || '(Belum diisi)'}</td>
            </tr>
            <tr>
              <td class="label-cell">Departemen</td>
              <td>${employee.id_department?.department_name || employee.staticData?.workInfo?.department || '(Belum diisi)'}</td>
              <td class="label-cell">Posisi</td>
              <td>${employee.id_jobposition?.jobposition_name || employee.staticData?.workInfo?.position || '(Belum diisi)'}</td>
            </tr>
            <tr>
              <td class="label-cell">Level Pekerjaan</td>
              <td colspan="3">${employee.id_job_level?.joblevel_name || '(Belum diisi)'}</td>
            </tr>
            <tr>
              <td class="label-cell">Grade</td>
              <td>${employee.grade || employee.staticData?.workInfo?.grade || '(Belum diisi)'}</td>
              <td class="label-cell">Branch</td>
              <td>${employee.staticData?.workInfo?.branch_name || '(Belum diisi)'}</td>
            </tr>
          </table>
          </div>
        
        <!-- BENEFIT -->
        <div class="section">
          <div class="section-title">BENEFIT</div>
          
          <table class="table">
            <tr>
              <td class="label-cell" style="width: 20%;">BPJS Ketenagakerjaan</td>
              <td style="width: 30%;">${employee.bpjs_tk || employee.staticData?.benefit?.lbpjs_ketenagakerjaan_no || '(Belum diisi)'}</td>
              <td class="label-cell" style="width: 20%;">BPJS Kesehatan</td>
              <td style="width: 30%;">${employee.bpjs_kes || employee.staticData?.benefit?.lbpjs_kesehatan_no || '(Belum diisi)'}</td>
            </tr>
            <tr>
              <td class="label-cell">Kategori Pajak</td>
              <td>${employee.tax_category || employee.staticData?.tax?.tax_category || '(Belum diisi)'}</td>
              <td class="label-cell">PPH21</td>
              <td>${employee.pph21 || employee.staticData?.tax?.pph21 || '(Belum diisi)'}</td>
            </tr>
          </table>
        </div>
        
        <!-- LAMARAN & KETERAMPILAN -->
        <div class="section">
          <div class="section-title">LAMARAN & KETERAMPILAN</div>
          
          <table class="table">
            <tr>
              <td class="label-cell" style="width: 35%;">Posisi yang dilamar</td>
              <td style="width: 65%;">${employee.desired_position || employee.staticData?.applicationSkills?.desired_position || '(Belum diisi)'}</td>
            </tr>
            <tr>
              <td class="label-cell">Gaji yang diharapkan</td>
              <td>${(employee.expected_salary || employee.staticData?.applicationSkills?.expected_salary) ? formatCurrency(employee.expected_salary || employee.staticData?.applicationSkills?.expected_salary) : '(Belum diisi)'}</td>
            </tr>
            <tr>
              <td class="label-cell">Alasan melamar</td>
              <td>${employee.apply_reason || employee.staticData?.applicationSkills?.apply_reason || '(Belum diisi)'}</td>
            </tr>
            <tr>
              <td class="label-cell">Keahlian</td>
              <td>${employee.skills || employee.staticData?.applicationSkills?.skills || '(Belum diisi)'}</td>
            </tr>
            <tr>
              <td class="label-cell">Program komputer yang dikuasai</td>
              <td>${employee.computer_programs || employee.staticData?.applicationSkills?.computer_programs || '(Belum diisi)'}</td>
            </tr>
            <tr>
              <td class="label-cell">Kemampuan mengemudi</td>
              <td>${employee.driving_ability || employee.staticData?.applicationSkills?.driving_ability || '(Belum diisi)'}</td>
            </tr>
          </table>
        </div>
        
        <!-- UMUM & KESEHATAN -->
        <div class="section">
          <div class="section-title">UMUM & KESEHATAN</div>
          
          <table class="table">
            <tr>
              <td class="label-cell" style="width: 45%;">Kekuatan Anda</td>
              <td style="width: 55%;">${employee.strength || employee.staticData?.generalHealth?.strength || '(Belum diisi)'}</td>
            </tr>
            <tr>
              <td class="label-cell">Kelemahan Anda</td>
              <td>${employee.weakness || employee.staticData?.generalHealth?.weakness || '(Belum diisi)'}</td>
            </tr>
            <tr>
              <td class="label-cell">Penyakit yang pernah / sering Anda derita</td>
              <td>${employee.common_illness || employee.staticData?.generalHealth?.common_illness || '(Belum diisi)'}</td>
            </tr>
            <tr>
              <td class="label-cell">Reaksi Anda terhadap kritik</td>
              <td>${employee.reaction_to_criticism || employee.staticData?.generalHealth?.reaction_to_criticism || '(Belum diisi)'}</td>
            </tr>
            <tr>
              <td class="label-cell">Pemeriksaan kesehatan terakhir</td>
              <td>${(employee.last_checkup || employee.staticData?.generalHealth?.last_checkup) ? formatDate(employee.last_checkup || employee.staticData?.generalHealth?.last_checkup) : '(Belum diisi)'}</td>
            </tr>
          </table>
        </div>
        
        <!-- LAIN-LAIN -->
        ${((employee.emergency_relations_data || employee.staticData?.emergency_relations || employee.guarantors_data || employee.staticData?.guarantors) && ((employee.emergency_relations_data?.length > 0 || employee.staticData?.emergency_relations?.length > 0) || (employee.guarantors_data?.length > 0 || employee.staticData?.guarantors?.length > 0))) ? `
        <div class="section">
          <div class="section-title">LAIN-LAIN</div>
          
          ${((employee.emergency_relations_data || employee.staticData?.emergency_relations) && (employee.emergency_relations_data?.length > 0 || employee.staticData?.emergency_relations?.length > 0)) ? `
          <div style="margin-bottom: 15px;">
            <div style="font-weight: bold; margin-bottom: 5px;">Relasi saat berhalangan:</div>
            <table class="table">
              <thead>
                <tr>
                  <th style="width: 25%;">Nama</th>
                  <th style="width: 10%;">Usia</th>
                  <th style="width: 30%;">Alamat</th>
                  <th style="width: 20%;">Telepon</th>
                  <th style="width: 15%;">Hubungan</th>
                </tr>
              </thead>
              <tbody>
                ${(employee.emergency_relations_data || employee.staticData?.emergency_relations || []).map(relation => `
                  <tr>
                    <td>${relation.name || '(Belum diisi)'}</td>
                    <td>${relation.age || '(Belum diisi)'}</td>
                    <td>${relation.address || '(Belum diisi)'}</td>
                    <td>${relation.phone || '(Belum diisi)'}</td>
                    <td>${relation.relationship || '(Belum diisi)'}</td>
                  </tr>
                `).join('')}
              </tbody>
            </table>
          </div>
          ` : ''}
          
          ${((employee.guarantors_data || employee.staticData?.guarantors) && (employee.guarantors_data?.length > 0 || employee.staticData?.guarantors?.length > 0)) ? `
          <div style="margin-bottom: 15px;">
            <div style="font-weight: bold; margin-bottom: 5px;">Penjamin di PT Eureka:</div>
            <table class="table">
              <thead>
                <tr>
                  <th style="width: 25%;">Nama</th>
                  <th style="width: 10%;">Usia</th>
                  <th style="width: 30%;">Alamat</th>
                  <th style="width: 20%;">Telepon</th>
                  <th style="width: 15%;">Hubungan</th>
                </tr>
              </thead>
              <tbody>
                ${(employee.guarantors_data || employee.staticData?.guarantors || []).map(guarantor => `
                  <tr>
                    <td>${guarantor.name || '(Belum diisi)'}</td>
                    <td>${guarantor.age || '(Belum diisi)'}</td>
                    <td>${guarantor.address || '(Belum diisi)'}</td>
                    <td>${guarantor.phone || '(Belum diisi)'}</td>
                    <td>${guarantor.relationship || '(Belum diisi)'}</td>
                  </tr>
                `).join('')}
              </tbody>
            </table>
          </div>
          ` : ''}
        </div>
        ` : ''}
        
      </div>
    </body>
    </html>
  `;
};

// Open form-style print preview
export const openFormPrintPreview = (printHTML) => {
  const printTab = window.open('', '_blank');
  printTab.document.write(printHTML);
  printTab.document.close();
  
  // Wait for content to load, then trigger print dialog
  printTab.onload = () => {
    setTimeout(() => {
      printTab.print();
    }, 1000);
  };
};